import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface LoginForm {
    phone: string;
    password: string;
}

@Injectable({
    providedIn: 'root',
})
export class AccountService {
    constructor(private http: HttpClient) { }
    setAuthToken(token: any) {
        window.localStorage.setItem('auth-token', token);
    }

    getAuthToken() {
        return localStorage.getItem('auth-token');
    }

    setAuthUser(user: any) {
        window.localStorage.setItem('auth-user', JSON.stringify(user));
    }

    getAuthUser() {
        return JSON.parse(localStorage.getItem('auth-user') as any);
    }
    getIPAddress() {
        return new Promise((resolve, reject) => {
            this.http.get("http://ip-api.com/json")
                .subscribe((res: any) => {
                    resolve(res);
                }
                );
        });
    }
}